import Portal from './Portal';

export default function Tooltip({ 
  x, 
  y, 
  children, 
  offsetX = 12, 
  offsetY = 12,
  animated = true 
}) {
  return (
    <Portal>
      <div
        className={[
          'fixed',
          'pointer-events-none',
          'z-[9999]',
          animated ? 'transition-opacity' : '',
          animated ? 'duration-200' : '',
          animated ? 'ease-out' : '',
          'opacity-100'
        ].filter(Boolean).join(' ')}
        style={{
          left: x + offsetX,
          top: y + offsetY,
        }}
      >
        {children}
      </div>
    </Portal>
  );
}